import React from "react";
import PageTemplate from "../components/PageTemplate";
import EmbedMobileHeader from "../components/embed/EmbedMobileHeader";
import EmbedBody from "../components/embed/EmbedBody";

const Embed = () => {
  const embedPulse = localStorage.getItem('embedPulse');
  if (embedPulse) {
    localStorage.removeItem('embedPulse');
  }

  return (
    <PageTemplate
      title='Embed'
      sidebarTitle='Embed Code'
      sidebarSubtitle={"Take it for yourself, or send it to your guy."}
      mobileHeader={<EmbedMobileHeader />}
    >
      <EmbedBody />
    </PageTemplate>
  );
};

export default Embed;
